import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import { SelectDropDown } from '../components/SelectDropdown';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);


export default function Barchart({order}) {

  const SelectedOption = [
    { label: "Daily", value: "1" },
    { label: "Weekly", value: "2" },
    { label: "Monthly", value: "3" },
  ];

  const handleSelect = (option) => {
    console.log("Selected option:", option);
  };

  const labels = order?.map((items) => items.statusName);
  const data = {
    labels: labels,
    datasets: [{
      label: 'Transaction',
      data: order?.map((items) => items.counts),
      backgroundColor: [
        'rgba(255, 99, 132)',
        'rgba(255, 159, 64)',
        'rgba(255, 205, 86)',
        'rgba(75, 192, 192)',
        'rgba(54, 162, 235)',
        'rgba(153, 102, 255)',
        'rgba(201, 203, 207)'
      ],
      borderWidth: 1,
      borderRadius: {
        topLeft: Number.MAX_VALUE,
        topRight: Number.MAX_VALUE,
        bottomLeft: 0,
        bottomRight: 0,
      },
      borderSkipped: "bottom",
      maxBarThickness: 50,
    }]
    
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
          <p className="text-xl text-primaryRed font-bold">Order Metric</p>
          <SelectDropDown options={SelectedOption} onSelect={handleSelect} />
      </div>
      <Bar data={data} options={options} />
    </div>
  );
}